// extracted by mini-css-extract-plugin
module.exports = {"root":"screens_root__dee2s","description":"screens_description__Of_lJ","button":"screens_button__t0qWo"};